/* eslint-disable import/prefer-default-export */
import * as coreUI from './core-ui-actions';
import { fetchServerAuthenticatedUser } from './index';

export function getUserAndTypes() {
    return dispatch => {
        const promises = [
            dispatch(fetchServerAuthenticatedUser()),
            dispatch(coreUI.fetchTypes()),
            dispatch(coreUI.fetchSearchTypes()),
            dispatch(coreUI.fetchUtrRangeTypes()),
            dispatch(coreUI.fetchPickleballRatingTypes()),
        ];

        const promisesResolved = promises.map(promise => promise.catch(() => undefined));
        return Promise.all(promisesResolved);
    };
}
